import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AbstractAppConfigService,
  APP_CONFIG_SERVICE,
  IHttpBasicResponse,
} from '@boxx/core';
import {
  IEventsApiProps,
  IEventsCommonProps,
  IEventsRepository,
  IUpsertEventPayload,
} from './IEvents.repository';
import * as moment from 'moment';

@Injectable()
export class EventsRepository implements IEventsRepository {
  constructor(
    @Inject(APP_CONFIG_SERVICE) private appSettings: AbstractAppConfigService,
    private httpClient: HttpClient
  ) {}

  getEvents(): Observable<IHttpBasicResponse<IEventsApiProps[]>> {
    // const d = new Date();
    // d.setMonth(d.getMonth() - 3);
    // const dateSplit = d.toLocaleDateString().split('/');
    // const dateFrom = dateSplit[2] + '-' + ((dateSplit[1].length < 2) ? ('0' + dateSplit[1]) : dateSplit[1]) + '-' + ((dateSplit[0].length < 2) ? ('0' + dateSplit[0]) : dateSplit[0]);
    const dateFrom = moment().format('YYYY-MM-DD');// moment().subtract(3, 'M').format('YYYY-MM-DD');
    return this.httpClient.get<IHttpBasicResponse<IEventsApiProps[]>>(
      `${this.getBaseUrl()}/?date_from=${dateFrom}`
    );
  }

  createEvent(
    payload: IUpsertEventPayload
  ): Observable<IHttpBasicResponse<IEventsApiProps>> {
    let params = new HttpParams();
    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        if (typeof payload[key] === 'object') {
          params = params.append(key, JSON.stringify(payload[key]));
        } else if (payload[key]) {
          params = params.append(key, payload[key]);
        }
      }
    }
    const body = params.toString();

    return this.httpClient.post<IHttpBasicResponse<IEventsApiProps>>(
      `${this.getBaseUrl()}/create`,
      body
    );
  }

  updateEvent(
    id: number,
    payload: IUpsertEventPayload
  ): Observable<IHttpBasicResponse<IEventsApiProps>> {
    let params = new HttpParams();
    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        if (typeof payload[key] === 'object') {
          params = params.append(key, JSON.stringify(payload[key]));
        } else if (payload[key]) {
          params = params.append(key, payload[key]);
        }
      }
    }
    const body = params.toString();

    return this.httpClient.post<IHttpBasicResponse<IEventsApiProps>>(
      `${this.getBaseUrl()}/update/${id}`,
      body
    );
  }

  deleteEvent(id: any): Observable<IHttpBasicResponse<null>> {
    return this.httpClient.delete<IHttpBasicResponse<null>>(
      `${this.getBaseUrl()}/delete/${id}`
    );
  }

  private getBaseUrl() {
    return `${this.appSettings.baseUrl()}/api/${this.appSettings.instance()}/v1/schedule`;
  }
}
